import { HttpParams } from '@angular/common/http';
import { Filter } from '../../../../../models/filter';

export interface IClienteFilter {
  // Cadastro
  cadastros: number[];

  // Situação
  situacoes: number[];

  // Origem
  origens: number[];
  idsCampanhasOrigens: number[];
  campanhaOrigemNull: boolean;
  idsCampanhasAquisicoes: number[];
  idsCampanhasOrigensAquisicoes: number[];

  // Canal de mídia social
  canaisMidiasSociais: number[];
  canalMidiaSocialNull: boolean;

  // Canal de venda
  idsCanaisVendaOrigem: number[];

  // Tipo de pessoa
  tipoPessoa: number;
  tiposPessoas: number[];

  // Periodicidade de compras
  idsPeriodicidadesCompras: number[];
  periodicidadeCompraSemana: number[];

  // Classificações
  idsClassificacoes: number[];

  // Grupo econômico
  idClienteGrupoEconomico: number;
  idsClientesGruposEconomicos: number[];

  // Pesquisa
  filterPsq: string;
  cnpjCpf: string;
  codigoIntegracaoErp: string;

  // Representante
  idRepresentante: number;
  idsOutrosRepresentantes: number[];
  idsRepresentantes: number[];

  // Acessos (usuários gerentes/atendentes vinculados ao cliente)
  idsGerentes: number[];
  idsAtendentes: number[];

  // Cliente atual
  idClienteAtual: number;

  // Localização
  idCidade: number;
  idCidadeSubRegiao: number;
  idCidadeSubRegiaoBairro: number;
  idEstado: number[];

  // Central de compras
  idClienteCentralCompras: number;

  // Data de cadastro
  dataCadastroInicial: string | null;
  dataCadastroFinal: string | null;

  // Análise financeira
  statusesAnaliseFinanceira: number[];

  // Regiões
  idsRegioes: number[];

  // Tags
  idsTags: number[];

  // Pessoas
  idsPessoas: number[];
}

/** Representa o Filter da entidade Cliente */
export class ClienteFilter implements Filter {
  isFilterDirty = false;

  cadastros: number[] = []; // Lista de cadastros

  /** Situação */
  situacoes: number[] = []; // Lista de situações

  origens: number[] = [];
  idsCampanhasOrigens: number[] = [];
  campanhaOrigemNull = false;
  idsCampanhasAquisicoes: number[] = [];
  idsCampanhasOrigensAquisicoes: number[] = [];
  canaisMidiasSociais: number[] = [];
  idsCanaisVendaOrigem: number[] = [];
  tipoPessoa: number;
  tiposPessoas: number[] = [];
  idsPeriodicidadesCompras: number[] = [];
  periodicidadeCompraSemana: number[] = [];
  idsClassificacoes: number[] = [];
  idClienteGrupoEconomico: number;
  idsClientesGruposEconomicos: number[] = [];
  filterPsq: string;
  cnpjCpf: string;
  codigoIntegracaoErp: string;
  idRepresentante: number;
  idsOutrosRepresentantes: number[] = []; // Para quando for pesquisado por mais de 1 representante
  idsGerentes: number[] = [];
  idsAtendentes: number[] = [];
  idClienteAtual: number;
  idCidade: number;
  idCidadeSubRegiao: number;
  idCidadeSubRegiaoBairro: number;
  idEstado: number[];
  idClienteCentralCompras: number;
  dataCadastroInicial: string;
  dataCadastroFinal: string;
  statusesAnaliseFinanceira: number[] = [];
  idsRegioes: number[] = [];
  idsTags: number[] = []; // IDs das tags associadas ao cliente
  idsRepresentantes: number[] = []; // IDs dos representantes associados ao cliente
  idsPessoas: number[] = []; // IDs das pessoas associadas ao cliente

  createParams(params: HttpParams): HttpParams {
    if (!params) {
      params = new HttpParams();
    }

    if (this.cadastros && this.cadastros.length > 0) {
      this.cadastros.forEach((cadastro) => {
        params = params.append('cadastro', cadastro.toString());
      });
    }

    if (this.idsTags && this.idsTags.length > 0) {
      this.idsTags.forEach((idTag) => {
        params = params.append('idsTags', idTag.toString());
      });
    }

    /** Pessoas */
    if (this.idsRepresentantes && this.idsRepresentantes.length > 0) {
      this.idsRepresentantes.forEach((idRepresentante) => {
        params = params.append('idsRepresentantes', idRepresentante.toString());
      });
    }

    if (this.idsPessoas && this.idsPessoas.length > 0) {
      this.idsPessoas.forEach((idPessoa) => {
        params = params.append('idsPessoas', idPessoa.toString());
      });
    }

    if (this.idsGerentes && this.idsGerentes.length > 0) {
      this.idsGerentes.forEach((idGerente) => {
        params = params.append('idsGerentes', idGerente.toString());
      });
    }

    if (this.idsAtendentes && this.idsAtendentes.length > 0) {
      this.idsAtendentes.forEach((idAtendente) => {
        params = params.append('idsAtendentes', idAtendente.toString());
      });
    }

    if (this.situacoes && this.situacoes.length > 0) {
      this.situacoes.forEach((situacao) => {
        params = params.append('situacao', situacao.toString());
      });
    }

    // Origens
    this.origens?.forEach((origem) => {
      params = params.append('origem', origem.toString());
    });

    // IDs Campanhas de Origens
    this.idsCampanhasOrigens?.forEach((idCampanhaOrigem) => {
      if (idCampanhaOrigem > 0) {
        params = params.append('idCampanhaOrigem', idCampanhaOrigem.toString());
      }
    });
    // Sem campanha de origem
    if (this.campanhaOrigemNull) {
      params = params.append('campanhaOrigemNull', 'true');
    }

    // IDs Campanhas de Aquisições
    this.idsCampanhasAquisicoes?.forEach((idCampanhaAquisicao) => {
      if (idCampanhaAquisicao > 0) {
        params = params.append(
          'idCampanhaAquisicao',
          idCampanhaAquisicao.toString()
        );
      }
    });

    // IDs Campanhas de Origens ou Aquisições
    this.idsCampanhasOrigensAquisicoes?.forEach((idCampanhaOrigemAquisicao) => {
      if (idCampanhaOrigemAquisicao > 0) {
        params = params.append(
          'idCampanhaOrigemAquisicao',
          idCampanhaOrigemAquisicao.toString()
        );
      }
    });

    // Canais de Mídias Socias
    this.canaisMidiasSociais?.forEach((canalMidiaSocial) => {
      if (canalMidiaSocial > 0) {
        params = params.append('canalMidiaSocial', canalMidiaSocial.toString());
      }
    });

    // Canais de Venda de Origem
    this.idsCanaisVendaOrigem?.forEach((idCanalVendaOrigem) => {
      params = params.append(
        'idCanalVendaOrigem',
        idCanalVendaOrigem.toString()
      );
    });

    // Tipo da Pessoa
    if (this.tipoPessoa) {
      params = params.append('tipoPessoa', this.tipoPessoa.toString());
    }
    this.tiposPessoas?.forEach(
      (tipoPessoa) =>
        (params = params.append('tipoPessoa', tipoPessoa.toString()))
    );

    // Periodicidades de Compras
    this.idsPeriodicidadesCompras?.forEach(
      (idPeriodicidadeCompra) =>
        (params = params.append(
          'idPeriodicidadeCompra',
          idPeriodicidadeCompra.toString()
        ))
    );
    // Periodicidades de Compras Semanas
    this.periodicidadeCompraSemana?.forEach(
      (periodicidadeCompraSemana) =>
        (params = params.append(
          'periodicidadeCompraSemana',
          periodicidadeCompraSemana.toString()
        ))
    );

    // Classificações de itens
    this.idsClassificacoes?.forEach((idClassificacao) => {
      if (idClassificacao > 0) {
        params = params.append('idClassificacao', idClassificacao.toString());
      }
    });
    // Grupo Econômico
    if (this.idClienteGrupoEconomico) {
      params = params.append(
        'idClienteGrupoEconomico',
        this.idClienteGrupoEconomico.toString()
      );
    }
    this.idsClientesGruposEconomicos?.forEach((id) => {
      params = params.append('idClienteGrupoEconomico', id.toString());
    });

    // Nome / Código Integração / CNPJ/CPF
    if (this.filterPsq && this.filterPsq.trim().length > 0) {
      params = params.append('filterPsq', this.filterPsq);
    }
    // CNPJ/CPF
    if (this.cnpjCpf && this.cnpjCpf.trim().length > 0) {
      params = params.append('cnpjCpf', this.cnpjCpf);
    }
    // Código Integração ERP
    if (
      this.codigoIntegracaoErp &&
      this.codigoIntegracaoErp.trim().length > 0
    ) {
      params = params.append('codigoIntegracaoErp', this.codigoIntegracaoErp);
    }

    // Representante
    if (this.idRepresentante) {
      params = params.append(
        'idRepresentante',
        this.idRepresentante.toString()
      );
    }
    if (
      this.idsOutrosRepresentantes &&
      this.idsOutrosRepresentantes.length > 0
    ) {
      this.idsOutrosRepresentantes.forEach((id) => {
        if (id > 0) {
          params = params.append('idRepresentante', id.toString());
        }
      });
    }

    // Cliente atual
    if (this.idClienteAtual) {
      params = params.append('idClienteAtual', this.idClienteAtual.toString());
    }

    // Cidade
    if (this.idCidade) {
      params = params.append('idCidade', this.idCidade.toString());
    }
    // Cidade Sub-Região
    if (this.idCidadeSubRegiao) {
      params = params.append(
        'idCidadeSubRegiao',
        this.idCidadeSubRegiao.toString()
      );
    }
    // Cidade Sub-Região Bairro
    if (this.idCidadeSubRegiaoBairro) {
      params = params.append(
        'idCidadeSubRegiaoBairro',
        this.idCidadeSubRegiaoBairro.toString()
      );
    }
    // Estado
    if (this.idEstado && this.idEstado.length > 0) {
      this.idEstado.forEach((id) => {
        params = params.append('idEstado', id.toString());
      });
    }
    // Central de Compras
    if (this.idClienteCentralCompras) {
      params = params.append(
        'idClienteCentralCompras',
        this.idClienteCentralCompras.toString()
      );
    }

    // Data de Cadastro
    if (this.dataCadastroInicial) {
      params = params.append('dataCadastroInicial', this.dataCadastroInicial);
    }
    if (this.dataCadastroFinal) {
      params = params.append('dataCadastroFinal', this.dataCadastroFinal);
    }

    // Statuses Análise Fianceira
    this.statusesAnaliseFinanceira?.forEach((statusAnaliseFinanceira) => {
      params = params.append(
        'statusAnaliseFinanceira',
        statusAnaliseFinanceira.toString()
      );
    });

    // IDs regiões
    this.idsRegioes?.forEach((idRegiao) => {
      if (idRegiao > 0) {
        params = params.append('idRegiao', idRegiao.toString());
      }
    });

    return params;
  }

  /** Limpa o filtro dos cadastros */
  clearCadastros() {
    this.cadastros = [];
  }

  /** Limpa o filtro das situações */
  clearSituacoes() {
    this.situacoes = [];
  }

  clear() {
    this.isFilterDirty = false;

    /** Cadastro */

    this.clearCadastros();

    /** Situação */

    this.clearSituacoes();

    this.origens = [];
    this.idsCampanhasOrigens = [];
    this.campanhaOrigemNull = false;
    this.idsCampanhasAquisicoes = [];
    this.idsCampanhasOrigensAquisicoes = [];
    this.canaisMidiasSociais = [];
    this.idsCanaisVendaOrigem = [];
    this.tipoPessoa = null;
    this.tiposPessoas = [];
    this.idsPeriodicidadesCompras = [];
    this.periodicidadeCompraSemana = [];
    this.idsClassificacoes = [];
    this.idClienteGrupoEconomico = null;
    this.idsClientesGruposEconomicos = [];
    this.filterPsq = null;
    this.cnpjCpf = null;
    this.codigoIntegracaoErp = null;
    this.idRepresentante = null;
    this.idsOutrosRepresentantes = [];
    this.idsGerentes = [];
    this.idsAtendentes = [];
    this.idClienteAtual = null;
    this.idCidade = null;
    this.idCidadeSubRegiao = null;
    this.idCidadeSubRegiaoBairro = null;
    this.idEstado = null;
    this.idClienteCentralCompras = null;
    this.dataCadastroInicial = null;
    this.dataCadastroFinal = null;
    this.statusesAnaliseFinanceira = [];
    this.idsRegioes = [];
    this.idsTags = [];
  }
}
